import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import ListYourItemsButton from '../ListYourItemsButton/ListYourItemsButton';
import css from './WhoIsCauseeFor.module.css';

// A single reusable icon used inside each seller-type card. The mockup uses a
// neutral placeholder glyph in a soft-green tile, so we keep one consistent mark.
const CardIcon = () => (
  <span className={css.cardIcon} aria-hidden="true">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 7L9.5 17.5L4 12"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const SELLER_TYPES = [
  {
    labelId: 'CustomLandingPage.whoIsFor.type.wholesalers.label',
    descriptionId: 'CustomLandingPage.whoIsFor.type.wholesalers.description',
  },
  {
    labelId: 'CustomLandingPage.whoIsFor.type.secondHand.label',
    descriptionId: 'CustomLandingPage.whoIsFor.type.secondHand.description',
  },
  {
    labelId: 'CustomLandingPage.whoIsFor.type.crafters.label',
    descriptionId: 'CustomLandingPage.whoIsFor.type.crafters.description',
  },
  {
    labelId: 'CustomLandingPage.whoIsFor.type.charityShops.label',
    descriptionId: 'CustomLandingPage.whoIsFor.type.charityShops.description',
  },
  {
    labelId: 'CustomLandingPage.whoIsFor.type.localBusinesses.label',
    descriptionId: 'CustomLandingPage.whoIsFor.type.localBusinesses.description',
  },
];

const WhoIsCauseeFor = () => {
  return (
    <div className={css.root}>
      <div className={css.cardGrid}>
        {SELLER_TYPES.map(type => (
          <div className={css.card} key={type.labelId}>
            <CardIcon />
            <div className={css.cardText}>
              <span className={css.cardLabel}>
                <FormattedMessage id={type.labelId} />
              </span>
              <span className={css.cardDescription}>
                <FormattedMessage id={type.descriptionId} />
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className={css.ctaWrapper}>
        <ListYourItemsButton linkClassName={css.ctaLink} buttonClassName={css.primaryCta}>
          <FormattedMessage id="CustomLandingPage.whoIsFor.cta" />
        </ListYourItemsButton>
      </div>
    </div>
  );
};

export default WhoIsCauseeFor;
